// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var DialogV5 = require("../../../uikit/reason/molecules/Dialog/DialogV5.bs.js");
var Intercom = require("../Intercom.bs.js");
var ButtonsV5 = require("../../../uikit/reason/atoms/Buttons/ButtonsV5.bs.js");
var EventLogs = require("../../EventLogs.bs.js");
var ViewStack = require("../ViewStack.bs.js");
var Text__Jsx3 = require("../../../uikit/reason/helpers/Text__Jsx3.bs.js");
var View__Jsx3 = require("../../../uikit/reason/helpers/View__Jsx3.bs.js");
var AuthSession = require("../../../utils/AuthSession.bs.js");
var UserSession = require("../UserSession/UserSession.bs.js");
var JsxRuntime = require("react/jsx-runtime");

function body(chapter) {
  return "Top Agent Network's " + chapter + " chapter has been put on hold as we focus our resources on our more active chapters across the country.\n      We appreciate your membership and will relaunch in $chapter when demand increases.";
}

function ClosedChapterOverlay$LoggedInDialog(props) {
  var logout = props.logout;
  var match = Intercom.useIntercom();
  var show = match.show;
  return JsxRuntime.jsxs(DialogV5.make, {
              title: "Your chapter has been put on hold",
              isOpen: true,
              ariaLabel: "Your chapter has been put on hold",
              onDismiss: (function (prim) {
                  
                }),
              showCloseButton: false,
              children: [
                JsxRuntime.jsx(Text__Jsx3.make, {
                      lineHeight: {
                        NAME: "float",
                        VAL: 1.5
                      },
                      children: body(props.chapter)
                    }),
                JsxRuntime.jsx(View__Jsx3.make, {
                      mt: "md"
                    }),
                JsxRuntime.jsxs(ViewStack.make, {
                      justifyContent: "flexEnd",
                      flexDirection: "row",
                      children: [
                        JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
                              onClick: (function (param) {
                                  show();
                                }),
                              children: "Contact support"
                            }),
                        JsxRuntime.jsx(ButtonsV5.PrimaryButton.make, {
                              onClick: (function (param) {
                                  logout();
                                }),
                              children: "Log out"
                            })
                      ]
                    })
              ]
            });
}

var LoggedInDialog = {
  make: ClosedChapterOverlay$LoggedInDialog
};

var closedChapters = [
  "101",
  "102"
];

function ClosedChapterOverlay(props) {
  var chapter = UserSession.useChapterInfoOpt();
  var recordEvent = EventLogs.useRecordEventByCurrentUser();
  var logout = function () {
    recordEvent(undefined, "Logout", undefined);
    AuthSession.logout();
  };
  if (chapter === undefined) {
    return null;
  }
  var displayName = chapter.displayName;
  if (displayName !== undefined && closedChapters.includes(chapter.id)) {
    return JsxRuntime.jsx(ClosedChapterOverlay$LoggedInDialog, {
                logout: (function () {
                    logout();
                  }),
                chapter: displayName
              });
  } else {
    return null;
  }
}

var make = ClosedChapterOverlay;

var $$default = ClosedChapterOverlay;

exports.body = body;
exports.LoggedInDialog = LoggedInDialog;
exports.closedChapters = closedChapters;
exports.make = make;
exports.default = $$default;
exports.__esModule = true;
/* DialogV5 Not a pure module */
